import * as React from "react";
import Content from "./parts/Content";
import Aside from "./parts/Aside";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ll_url } from "./utils/tools";
import InputPage from "./pages/InputPage";
import JobPage from "./pages/JobPage";
import HelpPage from "./pages/HelpPage";
import ExamplePage from "./pages/ExamplePage";
import AcknowledgementPage from "./pages/AcknowledgementPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsOfUsePage from "./pages/TermsOfUsePage";
import { basePath, toolDescription, toolKeywords, toolName, toolTitle, toolVersion } from "./settings";
import ScrollToTop from "./commons/ScrollToTop";
import { CookieConsent } from "@loschmidt/commons";
import ViewerPage from "./pages/ViewerPage";
import { Sidebar } from "./sidebar";
import { Body } from "./body";
import { useRef } from "react";
import { ReinitContextProvider } from "./ReinitContext";
import { Button } from "reactstrap";

function PageComponent() {

  const asideLeftRef = useRef<HTMLDivElement>(null);
  const beforeAsideLeftRef = useRef<HTMLDivElement>(null);
  const contentJob = () => (
    <>
      <div className="before-ll-aside-left" ref={beforeAsideLeftRef} />
      <div className="ll-aside-left" ref={asideLeftRef} />
      <Content>
        <JobPage asideLeftRef={asideLeftRef} beforeAsideLeftRef={beforeAsideLeftRef} />
      </Content>
    </>
  )

  const contentOthers = () => (
    <>
      <Content aside>
        <Route exact path={ll_url('/')} component={InputPage} />
        <Route path={ll_url('/help')} component={HelpPage} />
        <Route path={ll_url('/example')} component={ExamplePage} />
        <Route path={ll_url('/acknowledgements')} component={AcknowledgementPage} />
        <Route path={ll_url('/privacy')} component={PrivacyPage} />
        <Route path={ll_url('/terms-of-use')} component={TermsOfUsePage} />
      </Content>
      <Aside>
        <Sidebar/>
      </Aside>
    </>
  )
  
  return <>

    <ScrollToTop />

    <ReinitContextProvider>
      <Body>
        <Switch>
          <Route path={ll_url('/job/:jobId')} render={contentJob} />
          <Route render={contentOthers} />
        </Switch>
      </Body>
    </ReinitContextProvider>

    <CookieConsent basePath={basePath} renderBtn={
      ({onClick, children}) => (
        <Button onClick={onClick}>{children}</Button>
      )
    }/>
  </>
}

function PageComponentWithRouter() {
  return <BrowserRouter>

    <Helmet titleTemplate={`%s | ${toolName} ${toolVersion} – ${toolTitle}`} defaultTitle={`${toolName} ${toolVersion} – ${toolTitle}`}>
      <meta name="description" content={toolDescription} />
      <meta name="keywords" content={toolKeywords} />
    </Helmet>

    <Switch>
      <Route path={ll_url('/viewer/:jobId')} component={ViewerPage} />
      <Route component={PageComponent} />
    </Switch>

  </BrowserRouter>
}

export default PageComponentWithRouter;